import { useState, useEffect, useRef } from 'react';
import keyBy from 'lodash/keyBy';
import isFunction from 'lodash/isFunction';
import { getResultsWithoutComposeItems } from '@Pages/RetroSynthesis/ProjectRoute/ReaxysExamplesSearchService';

const cancelSearch = (searchRef) => {
  if (searchRef.current && isFunction(searchRef.current.cancel)) {
    searchRef.current.cancel();
  }
};

/* eslint-disable  no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
const updateResults = (updateAllowed, searchResultRef, requestRef, resultRequest, setResults) => {
  if (updateAllowed) {
    if (searchResultRef.current.searchId && searchResultRef.current.searchId !== resultRequest.queryId) {
      // clear items and cancel search if we get new search request
      searchResultRef.current.items = [];
      cancelSearch(requestRef);
    }

    searchResultRef.current.searchId = resultRequest.queryId;
    requestRef.current = getResultsWithoutComposeItems(resultRequest, (newItems) => {
      searchResultRef.current.items = searchResultRef.current.items.concat(
        newItems.map((item) => ({ ...item, queryId: resultRequest.queryId }))
      );
      setResults(keyBy(searchResultRef.current.items, 'id'));
    });
  } else {
    // clear results if no request
    setResults(undefined);
    searchResultRef.current = { searchId: null, items: [] };
  }
};

export const useTopResults = (resultItem, topResultsRequestRef, lastResultsRequestRef) => {
  const [results, setResults] = useState(undefined);
  const searchRef = useRef({ searchId: null, items: [] });

  useEffect(() => {
    if (resultItem) {
      // cancel previous last search if running - user switched step before finished
      cancelSearch(lastResultsRequestRef);
    }
    updateResults(resultItem, searchRef, topResultsRequestRef, resultItem, setResults);
  }, [resultItem]);

  // Clean-up on unmount - cancel results request
  useEffect(
    () => () => {
      cancelSearch(topResultsRequestRef);
    },
    []
  );

  return results;
};

export const useLastResults = (resultItem, lastResultsRequestRef, prevResultItem, prevResults) => {
  const [results, setResults] = useState(undefined);
  const searchRef = useRef({ searchId: null, items: [] });

  useEffect(() => {
    updateResults(
      // get last results only if top is finished
      resultItem && prevResults && prevResultItem && prevResultItem.queryId === Object.values(prevResults)[0].queryId,
      searchRef,
      lastResultsRequestRef,
      resultItem,
      setResults
    );
  }, [resultItem, prevResults, prevResultItem]);

  // Clean-up on unmount - cancel results request
  useEffect(
    () => () => {
      cancelSearch(lastResultsRequestRef);
    },
    []
  );

  return results;
};
